/// <reference types="@types/googlemaps"/>
import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  OnInit,
  AfterViewInit,
  Input,
} from '@angular/core';

@Component({
  selector: 'GooglePlacesComponent',
  template: `
    <input
      class="input p-2 form-control"
      type="text"
      placeholder="Enter address"
      [(ngModel)]="autocompleteInput"
      #addresstext
    />
  `,
})
export class GooglePlacesComponent implements OnInit, AfterViewInit {
  @Input() addressType: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  autocompleteInput: string;
  queryWait: boolean;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  public ClearInput() {
    this.autocompleteInput = '';
  }

  invokeEvent(place: any) {
    this.setAddress.emit(place);
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'za' },
        types: [this.addressType],
        // Types:
        // 'establishment' - business addresses
        // 'address' - full addresses only (i.e. cannot search for a suburb or country ONLY)
        // 'geocode' - full address as well as partial address such as suburbs or countries
      }
    );
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }
}
